"use strict";
/*
 *
 *  Filename........: schwammService.ts
 *  Project.........: logistik.app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @link...........: https://www.ybm-deutschland.de/
 *  @version........: 1.0
 *
 *  @since..........: 23.05.21, 12:30
 *  @author.........: helmi
 *
 *  @brief..........:
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 *  Filename........: picklistService.ts
 *  Project.........: logistik-app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @version........: 1.0
 *
 *  @since..........: 14.10.20, 12:46
 *  @author.........: robin
 *
 *  @brief..........:
 */
var axios_1 = __importDefault(require("axios"));
var DataService_1 = require("@app/services/DataService");
var picklistService_1 = __importDefault(require("@app/services/picklistService"));
var picklist_1 = __importDefault(require("@app/types/picklist"));
var SchwammService = /** @class */ (function (_super) {
    __extends(SchwammService, _super);
    function SchwammService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.picklistSerice = picklistService_1.default;
        return _this;
    }
    //printAll(picklistIds: any[]) {
    //    return axios.post(this.getApiUrl()+'/printAll', {ids: picklistIds}, {responseType: "blob"}).then((response) => {
    //        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
    //        const fileLink = document.createElement('a');
    //        fileLink.href = url;
    //        fileLink.setAttribute('download', 'picklist.pdf');
    //        document.body.appendChild(fileLink);
    //        fileLink.click();
    //    });
    //}
    SchwammService.prototype.getByOrderNumber = function (orderNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.picklistSerice.getByOrderNumber(encodeURIComponent(orderNumber))];
            });
        });
    };
    SchwammService.prototype.pickItem = function (orderNumber, scanCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.post(this.getApiUrl() + '/' + encodeURIComponent(orderNumber) + '/pick', { barcode: scanCode })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SchwammService.prototype.finishPicking = function (orderNumber, picklist) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.picklistSerice.finishPicking(encodeURIComponent(orderNumber), picklist)];
            });
        });
    };
    return SchwammService;
}(DataService_1.DataService));
exports.default = new SchwammService(function (DTO) { return new picklist_1.default(DTO); }, 'schwamm/picklist', 2);
